/** Shared by the form and its skeleton so the page doesn't shift when the settings load: two columns from `lg`. */
export const COMPANY_PAGE_GRID = 'grid max-w-6xl gap-6 lg:grid-cols-2 lg:items-start';
